import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { animated } from "@react-spring/web";
import { Button, Col, Row, Typography } from "antd";
import { emitEvent, useMobileQuery } from "utils/utils";
import { useScrollableList } from "utils/useScrollableList";
import i18n from "i18next";

export const Paginator = <T,>({
  render: Render,
  items,
  page,
  onPageChange,
  showFaq,
}: {
  items: T[];
  page: number;
  onPageChange: (page: number) => void;
  render: (x: { item: T }) => JSX.Element;
  showFaq?: boolean;
}) => {
  const isMobile = useMobileQuery();
  const [component, props] = useScrollableList<HTMLDivElement>(
    items.length,
    page,
    onPageChange
  );

  if (items.length === 0) return <></>;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        touchAction: "none",
      }}
      ref={component}
    >
      <div style={{ flex: 1, position: "relative", overflow: "hidden" }}>
        {props.map((style, i) => (
          <animated.div
            // {...(!isMobile ? bind() : {})}
            key={i}
            style={{
              ...style,
              position: "absolute",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Render item={items[i]} />
          </animated.div>
        ))}
      </div>

      <style>
        {`
          .__iconButton {
            border-radius: 60px;
            padding: 8px;
            width: 40px;
            height: 40px;
            color: #111;
            background: #F9FBFE;
            border: 1px solid #8A95BD;
            box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
          }

          .__iconButton:hover {
            color: #666;
            border: 1px solid #8A95BD;
            box-shadow: 0px 4px 24px rgba(100, 100, 100, 0.12);
          }
        `}
      </style>
      <Row
        gutter={32}
        style={{ paddingTop: 40 }}
        align="middle"
        justify="space-between"
        wrap={false}
      >
        {items.length > 1 && (
          <Col style={{ flexShrink: 0 }}>
            <Row align="middle" wrap={false} gutter={32}>
              <Col>
                <Button
                  className="__iconButton"
                  disabled={page - 1 < 0}
                  onClick={() => onPageChange(page - 1)}
                  icon={<LeftOutlined />}
                />
              </Col>
              <Col style={{ flexShrink: 0 }}>
                <Typography.Text
                  style={{
                    color: "#BFBFBF",
                    filter: isMobile ? "invert(1)" : "",
                    fontSize: "16px",
                  }}
                >
                  {i18n.t("widget.pagination", {
                    page: page + 1,
                    pages: items.length,
                  })}
                </Typography.Text>
              </Col>
              <Col>
                <Button
                  className="__iconButton"
                  disabled={page + 1 >= items.length}
                  onClick={() => onPageChange(page + 1)}
                  icon={<RightOutlined />}
                />
              </Col>
            </Row>
          </Col>
        )}
        {showFaq && (
          <Col style={{ color: "#BFC9E9" }}>
            <Button
              type="text"
              onClick={() => emitEvent("widgetFaqClick")}
              style={{ color: "#BFC9E9", padding: 0 }}
            >
              {i18n.t("widget.faq")}
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
};
